// import React from 'react';
// import { hydrateRoot, createRoot } from 'react-dom/client';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { Provider } from 'react-redux';
// import { store } from './redux/store/store.js';

// // const root = ReactDOM.createRoot(document.getElementById('root'));
// const rootElement = document.getElementById('root');

// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//     <App />
//     </Provider>
//   </React.StrictMode>
// );

// if (rootElement.hasChildNodes()) {
//   hydrateRoot(rootElement, AppWithProvider);
// } else {
//   createRoot(rootElement).render(AppWithProvider);
// }


// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then(registrations => {
//     registrations.forEach(registration => {
//       registration.unregister();
//     });
//   });
// }

// reportWebVitals();
import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store/store.js';

const rootElement = document.getElementById('root');

const AppWithProvider = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, AppWithProvider);
} else {
  createRoot(rootElement).render(AppWithProvider);
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
    });
  });
}

reportWebVitals();
